// bootstrap
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
// others
import { useState, useEffect } from "react"
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import Select from 'react-select'
import GeoJSONparser from 'geojson'
import * as tokml from "@fulcrumapp/tokml"
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import { v4 as uuidv4 } from 'uuid';
import InputGroup from 'react-bootstrap/InputGroup';
import * as turf from "@turf/turf";


import {
    useAuth

} from '../../contexts/authContext';


import { faQuestionCircle, faMinus, faPlus, faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { queryAssayAnumberWFS, queryAssaySampleIdWFS } from './AssayOverlay';
import { debouncedQueryAssayWFS } from './AssayOverlayOptimized';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
}))

export const defaultAssayMArkerColourSettings = (
    [
        {
            id: uuidv4(),
            moreThan: 100,
            color: "#800080"
        },
        {
            id: uuidv4(),
            moreThan: 50,
            color: "#FF0000"
        },
        {
            id: uuidv4(),
            moreThan: 20,
            color: "#FFA500"
        },
        {
            id: uuidv4(),
            moreThan: 0,
            color: "#0000FF"
        }
    ]);


export const sampleTypeDataPreSelected = [
    { value: 'ROCKCHIP', label: 'ROCKCHIP' },
    { value: 'SHALLOWSURFDRILL', label: 'SHALLOWSURFDRILL' },
    { value: 'SOIL', label: 'SOIL' },
    { value: 'STREAMSED', label: 'STREAMSED' }
];


function NumberInputField({ setValue, value }) {
    const [query, setQuery] = useState(value);

    useEffect(() => {
        if (query !== value) {
            const timeOutId = setTimeout(() => setValue(query), 500);
            return () => clearTimeout(timeOutId);
        }
    }, [query]);


    useEffect(() => {
        setQuery(value);
    }, [value]);

    return (
        <>
            <Form.Control
                size="sm"
                type="number"
                value={query}
                onChange={event => setQuery(event.target.valueAsNumber)}
            />
        </>
    );
}

export function AssayQueryTool({ map, markers, setMarkers, assayMarkerColourSettings, setAssayMarkerColourSettings, assayFilters, setAssayFilters }) {

    const { currentUser } = useAuth()

    // TODO Make this Dynamic
    const sampletypedata = [{ value: 'DRILLSPOIL', label: 'DRILLSPOIL' },
    { value: 'MINEDUMP', label: 'MINEDUMP' },
    { value: 'ROCKCHIP', label: 'ROCKCHIP' },
    { value: 'SHALLOWSURFDRILL', label: 'SHALLOWSURFDRILL' },
    { value: 'SOIL', label: 'SOIL' },
    { value: 'STREAMSED', label: 'STREAMSED' },
    { value: 'UNKN', label: 'UNKN' },
    { value: 'VEGETATION', label: 'VEGETATION' },
    { value: 'WATER', label: 'WATER' }];



    const [selectedSampleTypeData, setSelectedSampleTypeData] = useState(sampleTypeDataPreSelected);
    const [totalResults, setTotalResults] = useState(0);

    function markersToKml() {

        var kml = tokml(markers, { name: 'kml_title', description: 'description' });

        const url = window.URL.createObjectURL(new Blob([kml]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.kml";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

    }

    function getColourForMarker(assay) {
        const heatmapSteps = assayMarkerColourSettings.toSorted((a, b) => b.moreThan - a.moreThan);
        const range = heatmapSteps.find(element => { return parseInt(assay.properties.au_ppb) > element.moreThan });
        return range.color;
    }

    function markersToGeoJson() {
        const exportdata = markers;

        exportdata.features.map((feature) => {
            feature.properties.colour = getColourForMarker(feature).slice(1);
        });

        const url = window.URL.createObjectURL(new Blob([JSON.stringify(exportdata)]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.geojson";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    async function LookupANumber(e) {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());


        /*
        
                const result = await GoldFinderApi.get("/geojson/soil-samples/" + data.anumber);
                setMarkers(result.data.result);
                */
    }

    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto"
        })
    };

    async function simpleQuery() {

        const data = {
            ...assayFilters,
            nullValues: false,
            ppblt: 9999,
            sampletypedata: assayFilters.type.map(e => e.value),
            bounds: {
                NE: map.getBounds().getNorthEast(),
                SW: map.getBounds().getSouthWest()
            },
            au_dataset: "public.au_only_ss_assay_ppb_v1",
            querying_user: currentUser.displayName ? currentUser.displayName : currentUser.email
        }

        if (data.bounds.SW !== undefined) {
            const result = await GoldFinderApi.post("/geojson/soil-samples", {
                data
            });
            setMarkers(result.data.result);
            setTotalResults(result.data.totalResults);
        }

    }

    async function advancedQuery() {
        const data = {
            ...assayFilters,
            sampletypedata: assayFilters.type.map(e => e.value),
            bounds: {
                NE: map.getBounds().getNorthEast(),
                SW: map.getBounds().getSouthWest()
            },
            au_dataset: "public.au_only_ss_assay_ppb_v1",
            querying_user: currentUser.displayName ? currentUser.displayName : currentUser.email
        }


        if (data.bounds.SW !== undefined) {
            const result = await GoldFinderApi.post("/geojson/soil-samples", {
                data
            });
            setMarkers(result.data.result);
            setTotalResults(result.data.totalResults);
        }
    }

    function AccordianHeader({ returnedResults, localTotalResults }) {
        if (returnedResults < localTotalResults) {
            return (
                <Alert key="warning" variant="warning">
                    Note: {returnedResults} , of {localTotalResults} of samples displayed within the defined bounds, zoom in closer or increase Max Results
                </Alert>
            )
        } else {
            return <>Total Results: {returnedResults}</>
        }
    }

    const setPpbLessThan = (val) => {
        setAssayFilters({ ...assayFilters, ppblt: val.target.valueAsNumber });
    }

    const setPpbMoreThan = (val) => {
        setAssayFilters({ ...assayFilters, ppbmt: val.target.valueAsNumber });
    }

    const setMaxResults = (val) => {
        setAssayFilters({ ...assayFilters, maxresults: val.target.valueAsNumber })
    }

    // type
    const setAssayType = (typesIn) => {
        setAssayFilters({ ...assayFilters, type: typesIn })
    }
    // include Null Values
    const toggleNullValues = () => {
        setAssayFilters({ ...assayFilters, nullValues: !assayFilters.nullValues })
    }

    const addRangeEntry = () => {
        setAssayMarkerColourSettings([...assayMarkerColourSettings, {
            id: uuidv4(),
            moreThan: 1234,
            color: "black"
        }])

    }

    const removeRangeEntry = (id) => {
        setAssayMarkerColourSettings(assayMarkerColourSettings.filter((setting) => {
            if (setting.id !== id) {
                return true;
            } else return false;
        }))
    }

    const updateMoreThanValue = (id, value) => {
        const arr = assayMarkerColourSettings.map((e) => {
            if (e.id === id) {
                e.moreThan = value;//value.target.valueAsNumber;
            }
            return e;
        });
        setAssayMarkerColourSettings([...arr]);
    }

    const updateColourValue = (id, value) => {
        const arr = assayMarkerColourSettings.map((e) => {
            if (e.id === id) {
                e.color = value.target.value;
            }
            return e;
        });
        setAssayMarkerColourSettings([...arr]);
    }

    const AssayMarkerColourDisplay = (assayMarkerColourSettings) => {


        const orderedAssayMarkerArray = assayMarkerColourSettings.toSorted((a, b) => b.moreThan - a.moreThan);



        const rows = [];
        for (let i = 0; i < orderedAssayMarkerArray.length; i++) {


            const next = i - 1;
            rows.push(
                <tr>
                    <td style={{ textAlign: 'right' }}>
                        <button onClick={e => removeRangeEntry(orderedAssayMarkerArray[i].id)} className='btn btn-danger btn-sm '>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <input type="color" id="head" onChange={val => updateColourValue(orderedAssayMarkerArray[i].id, val)} name="head" value={orderedAssayMarkerArray[i].color} />
                    </td>
                    <td>
                        <Row>
                            <Col>
                                <NumberInputField
                                    id={'val' + orderedAssayMarkerArray[i].id}
                                    value={orderedAssayMarkerArray[i].moreThan}
                                    setValue={val => updateMoreThanValue(orderedAssayMarkerArray[i].id, val)}
                                />
                            </Col>
                            <Col>
                                <Form.Label column="sm">
                                    To  {i !== 0 ? orderedAssayMarkerArray[next].moreThan - 1 : "9999"}
                                </Form.Label>
                            </Col>
                        </Row>

                    </td>
                </tr>
            );
        }

        return rows;
    }

    return (
        <>
            <div>
                <Row className="justify-content-center" >
                    <AccordianHeader returnedResults={markers.features.length} localTotalResults={totalResults} />
                </Row>
                <Tabs
                    id="uncontrolled-tab-example"
                    className="mb-3">
                    <Tab eventKey="simple" title="Simple">
                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB More than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppbmt}
                                    onChange={setPpbMoreThan}
                                    type='number'
                                    step="1"
                                    required />
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>
                                    Max Results:
                                    <FontAwesomeIcon
                                        title="Maximum on-screen search results to be displayed. Note: Absolute Maximum allowed is 3000 due to database & rendering slowdowns"
                                        style={{ marginLeft: 5 }}
                                        icon={faQuestionCircle} />
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    name='maxresults'
                                    defaultValue={assayFilters.maxresults}
                                    onChange={setMaxResults}
                                    max="3000"
                                    min="0"
                                    type='number' required />
                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Label column="sm" style={{ fontSize: 12 }} >Sample Type</Form.Label>
                            <Select isMulti='true'
                                defaultValue={assayFilters.type}
                                onChange={setAssayType}
                                options={sampletypedata}
                                styles={SelectCustomStyles}
                                required />
                        </Form.Group>
                        <br />
                        <Row>
                            <Col className='text-center'  >
                                <button className="btn btn-primary btn-sm" onClick={simpleQuery}>Search current map view</button>
                            </Col>
                        </Row>
                    </Tab>

                    <Tab eventKey="complex" title="Advanced">

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB Less than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppblt}
                                    type='number'
                                    onChange={setPpbLessThan}
                                    step="1"
                                    required />
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB More than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppbmt}
                                    onChange={setPpbMoreThan}
                                    type='number'
                                    step="1"
                                    required />
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>
                                    Max Results:
                                    <FontAwesomeIcon
                                        title="Maximum on-screen search results to be displayed. Note: Absolute Maximum allowed is 3000 due to database & rendering slowdowns"
                                        style={{ marginLeft: 5 }}
                                        icon={faQuestionCircle} />
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    name='maxresults'
                                    defaultValue={assayFilters.maxresults}
                                    onChange={setMaxResults}
                                    max="3000"
                                    min="0"
                                    type='number' required />

                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Label column="sm" style={{ fontSize: 12 }} >Sample Type</Form.Label>
                            <Select isMulti='true'
                                defaultValue={assayFilters.type}
                                onChange={setAssayType}
                                options={sampletypedata}
                                styles={SelectCustomStyles}
                                required />
                        </Form.Group>

                        <br />
                        <Row>
                            <Col>
                                <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-top"> Since the Database is incomplete, manual lookup of the Assay report will be required </Tooltip>}
                                    placement="top" // You can choose other placements like "right", "bottom", "left" 
                                >
                                    <Form.Check // prettier-ignore

                                        checked={assayFilters.nullValues}
                                        onChange={() => toggleNullValues()}
                                        name="nullValues"
                                        label="Include Samples With Missing PPB Values"
                                    />
                                </OverlayTrigger>
                            </Col>
                        </Row>

                        <Row>
                            <Col className='text-center'  >
                                <button className="btn btn-primary btn-sm" onClick={advancedQuery}>Search current map view</button>
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="anumberr" title="A Number">

                        <Form onSubmit={LookupANumber} >


                            <Form.Label style={{ fontSize: 12 }} column="sm" >Display all soil samples within this A Number</Form.Label>
                            <Row>
                                <Col>
                                    <InputGroup className="mb-2">
                                        <InputGroup.Text>A</InputGroup.Text>
                                        <Form.Control size="sm" name='anumber' type='number' required />
                                    </InputGroup>
                                </Col>
                                <Col>
                                    <button className="btn btn-primary btn-sm" type="submit">Lookup</button>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="legend" title="Legend">
                        <Table striped bordered >
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}></th>
                                    <th style={{ width: '20%' }} >Colour</th>
                                    <th>Range</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AssayMarkerColourDisplay(assayMarkerColourSettings)}
                                <tr>
                                    <td></td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input type="color" disabled={true} id="head" name="head" value={"#ffffff"} />
                                    </td>
                                    <td>
                                        <Row>
                                            <Form.Label column="sm">
                                                Missing Values
                                            </Form.Label>
                                        </Row>
                                    </td>
                                </tr>
                            </tbody>


                            <button style={{ margin: 10 }} onClick={addRangeEntry} className='btn btn-success btn-sm '>
                                <i className='fa fa-solid fa-plus'></i>
                            </button>
                            <button style={{ margin: 10 }} onClick={(e) => { setAssayMarkerColourSettings(defaultAssayMArkerColourSettings) }} className='btn btn-warning btn-sm '>
                                Reset
                            </button>


                        </Table>
                    </Tab>
                </Tabs>
                <br />
                <Row>
                    <Col className='text-center mb-1'  >
                        <button className="btn btn-secondary btn-sm" onClick={markersToKml}>Export to results to KML file</button>
                    </Col>
                    {/*
                    
                    <Col className='text-center'  >
                        <button className="btn btn-secondary btn-sm" onClick={markersToGeoJson}>Export to results to GEOJSON file</button>
                    </Col>       
                    */}

                </Row>
                <Row>
                    <Col className='text-center mb-3'  >
                        Note: Export is limited to top 500 samples
                    </Col>
                </Row>






            </div>


        </>

    )
}




export function AssayQueryToolMapLibre({ assayGeoJson,
    assayMarkerColourSettings, setAssayMarkerColourSettings, assayFilters,
    setAssayFilters, setAssayGeoJson, goldfindermap }) {

    const { currentUser } = useAuth()

    // TODO Make this Dynamic
    const sampletypedata = [{ value: 'DRILLSPOIL', label: 'DRILLSPOIL' },
    { value: 'MINEDUMP', label: 'MINEDUMP' },
    { value: 'ROCKCHIP', label: 'ROCKCHIP' },
    { value: 'SHALLOWSURFDRILL', label: 'SHALLOWSURFDRILL' },
    { value: 'SOIL', label: 'SOIL' },
    { value: 'STREAMSED', label: 'STREAMSED' },
    { value: 'UNKN', label: 'UNKN' },
    { value: 'VEGETATION', label: 'VEGETATION' },
    { value: 'WATER', label: 'WATER' }];



    const [selectedSampleTypeData, setSelectedSampleTypeData] = useState(sampleTypeDataPreSelected);
    const [totalResults, setTotalResults] = useState(0);


    const [anumber, setAnumber] = useState(0);
    const [sampleId, setSampleId] = useState('');

    function markersToKml() {
        const exportGeoJson = assayGeoJson;

        exportGeoJson.features = assayGeoJson.features.slice(0,500);

        exportGeoJson.features = exportGeoJson.features.map((m) => {
            m.properties.kml_title = "AU PPB: " + m.properties.au_ppb;
            m.properties.description =
              "\n Unique ID: " + m.properties.id +
              "\n AU PPB: " + m.properties.au_ppb +
              "\n Sample Type: " + m.properties.surfacesampletype +
              "\n A Number : " + m.properties.anumber +
              "\n Company Sample ID: " + m.properties.companysampleid;
      
            return m
          })

        var kml = tokml(exportGeoJson, { name: 'kml_title', description: 'description' });

        const url = window.URL.createObjectURL(new Blob([kml]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.kml";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

    }

    function getColourForMarker(assay) {
        const heatmapSteps = assayMarkerColourSettings.toSorted((a, b) => b.moreThan - a.moreThan);
        const range = heatmapSteps.find(element => { return parseInt(assay.properties.au_ppb) > element.moreThan });
        return range.color;
    }

    /*
    function markersToGeoJson() {
        const exportdata = markers;

        exportdata.features.map((feature) => {
            feature.properties.colour = getColourForMarker(feature).slice(1);
        });

        const url = window.URL.createObjectURL(new Blob([JSON.stringify(exportdata)]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.geojson";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    */

    // TODO FIX THIS
    async function LookupANumber(e) {

        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        setAssayFilters({ ...assayFilters, anumber: data.anumber })

        if (!data.anumber || data.anumber === 0 || isNaN(data.anumber)) {
            // Don't process invalid anumber values in form submission
            return;
        }
        
        queryAssayAnumberWFS(data.anumber).then((response) => {
            if (response.data && response.data.features && response.data.features.length > 0) {
                const turfBounds = turf.bbox(response.data);
                goldfindermap.fitBounds([
                    [turfBounds[0], turfBounds[1]],
                    [turfBounds[2], turfBounds[3]]])
                setAssayGeoJson(response.data);
            } else {
                // Set empty results if no features found
                setAssayGeoJson({
                    type: "FeatureCollection",
                    features: []
                });
                alert('No soil samples found for A Number: ' + data.anumber);
            }
        }).catch((error) => {
            console.error('Error looking up A Number:', error);
            alert('Error looking up A Number: ' + data.anumber);
        });


        //71479
        //const result = await GoldFinderApi.get("/geojson/soil-samples/" + data.anumber);
        //setMarkers(result.data.result);
    }

    async function LookupSampleId(e) {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        if (!data.sampleId || data.sampleId === '') return

        queryAssaySampleIdWFS(data.sampleId).then((response) => {
            if (response.data && response.data.features && response.data.features.length > 0) {
                const turfBounds = turf.bbox(response.data);
                goldfindermap.fitBounds([
                    [turfBounds[0], turfBounds[1]],
                    [turfBounds[2], turfBounds[3]]])
                setAssayGeoJson(response.data);
            } else {
                alert('No soil sample found with ID or Company Sample ID: ' + data.sampleId);
            }
        }).catch((error) => {
            console.error('Error looking up sample ID:', error);
            alert('Error looking up sample ID or Company Sample ID: ' + data.sampleId);
        });
    }

    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto"
        })
    };

    const setPpbLessThan = (val) => {
        setAssayFilters({ ...assayFilters, ppblt: val.target.valueAsNumber });
    }

    const setPpbMoreThan = (val) => {
        setAssayFilters({ ...assayFilters, ppbmt: val.target.valueAsNumber });
    }

    const setMaxResults = (val) => {
        setAssayFilters({ ...assayFilters, maxresults: val.target.valueAsNumber })
    }

    // type
    const setAssayType = (typesIn) => {
        setAssayFilters({ ...assayFilters, type: typesIn })
    }
    // include Null Values
    const toggleNullValues = () => {
        setAssayFilters({ ...assayFilters, nullValues: !assayFilters.nullValues })
    }

    // Load-date (gswa_load_date) period filter
    const toggleDateFilter = () => {
        setAssayFilters({ ...assayFilters, dateFilterEnabled: !assayFilters.dateFilterEnabled })
    }
    const setDateFrom = (val) => {
        setAssayFilters({ ...assayFilters, dateFrom: val.target.value })
    }
    const setDateTo = (val) => {
        setAssayFilters({ ...assayFilters, dateTo: val.target.value })
    }

    // Shared month/year range control, rendered in both the Simple and Advanced
    // tabs. Filters soil samples by their DMPE load date (gswa_load_date).
    //
    // NOTE: this is a plain render helper called as `{loadDatePeriodFilter()}`,
    // NOT a `<LoadDatePeriodFilter />` component. Defining it as a nested
    // component and mounting it as an element gives it a new identity on every
    // parent render, so React remounts the whole subtree on each keystroke/
    // toggle — that caused the sidebar flicker (and dropped input focus).
    // Calling it as a function inlines the JSX so React can reconcile normally.
    const loadDatePeriodFilter = () => (
        <>
            <hr className="my-2" />
            <Form.Group>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-load-date">Filter samples by the month/year they were loaded into DMPE</Tooltip>}
                >
                    <Form.Check
                        type="checkbox"
                        checked={!!assayFilters.dateFilterEnabled}
                        onChange={toggleDateFilter}
                        name="dateFilterEnabled"
                        label="Filter by DMPE load date"
                    />
                </OverlayTrigger>
                {assayFilters.dateFilterEnabled && (
                    <Row className="mt-2">
                        <Col>
                            <Form.Label column="sm" style={{ fontSize: 12 }}>From (month)</Form.Label>
                            <Form.Control
                                size="sm"
                                type="month"
                                value={assayFilters.dateFrom || ''}
                                max={assayFilters.dateTo || undefined}
                                onChange={setDateFrom}
                            />
                        </Col>
                        <Col>
                            <Form.Label column="sm" style={{ fontSize: 12 }}>To (month)</Form.Label>
                            <Form.Control
                                size="sm"
                                type="month"
                                value={assayFilters.dateTo || ''}
                                min={assayFilters.dateFrom || undefined}
                                onChange={setDateTo}
                            />
                        </Col>
                    </Row>
                )}
            </Form.Group>
        </>
    );

    const addRangeEntry = () => {
        setAssayMarkerColourSettings([...assayMarkerColourSettings, {
            id: uuidv4(),
            moreThan: 1234,
            color: "black"
        }])

    }

    const removeRangeEntry = (id) => {
        setAssayMarkerColourSettings(assayMarkerColourSettings.filter((setting) => {
            if (setting.id !== id) {
                return true;
            } else return false;
        }))
    }

    const updateMoreThanValue = (id, value) => {
        const arr = assayMarkerColourSettings.map((e) => {
            if (e.id === id) {
                e.moreThan = value;//value.target.valueAsNumber;
            }
            return e;
        });
        setAssayMarkerColourSettings([...arr]);
    }

    const updateColourValue = (id, value) => {
        const arr = assayMarkerColourSettings.map((e) => {
            if (e.id === id) {
                e.color = value.target.value;
            }
            return e;
        });
        setAssayMarkerColourSettings([...arr]);
    }

    const AssayMarkerColourDisplay = (assayMarkerColourSettings) => {


        const orderedAssayMarkerArray = assayMarkerColourSettings.toSorted((a, b) => b.moreThan - a.moreThan);



        const rows = [];
        for (let i = 0; i < orderedAssayMarkerArray.length; i++) {


            const next = i - 1;
            rows.push(
                <tr>
                    <td style={{ textAlign: 'right' }}>
                        <button onClick={e => removeRangeEntry(orderedAssayMarkerArray[i].id)} className='btn btn-danger btn-sm '>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <input type="color" id="head" onChange={val => updateColourValue(orderedAssayMarkerArray[i].id, val)} name="head" value={orderedAssayMarkerArray[i].color} />
                    </td>
                    <td>
                        <Row>
                            <Col>
                                <NumberInputField
                                    id={'val' + orderedAssayMarkerArray[i].id}
                                    value={orderedAssayMarkerArray[i].moreThan}
                                    setValue={val => updateMoreThanValue(orderedAssayMarkerArray[i].id, val)}
                                />
                            </Col>
                            <Col>
                                <Form.Label column="sm">
                                    To  {i !== 0 ? orderedAssayMarkerArray[next].moreThan - 1 : "9999"}
                                </Form.Label>
                            </Col>
                        </Row>

                    </td>
                </tr>
            );
        }

        return rows;
    }

    return (
        <>
            <div>
                <Row className="justify-content-center" >
                </Row>
                <Tabs
                    id="uncontrolled-tab-example"
                    className="mb-3">
                    <Tab eventKey="simple" title="Simple">
                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB More than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppbmt}
                                    onChange={setPpbMoreThan}
                                    value={assayFilters.ppbmt}
                                    type='number'
                                    step="1"
                                    required />
                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Label column="sm" style={{ fontSize: 12 }} >Sample Type</Form.Label>
                            <Select isMulti='true'
                                defaultValue={assayFilters.type}
                                onChange={setAssayType}
                                options={sampletypedata}
                                styles={SelectCustomStyles}
                                required />
                        </Form.Group>
                        {loadDatePeriodFilter()}

                    </Tab>

                    <Tab eventKey="complex" title="Advanced">

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB Less than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppblt}
                                    value={assayFilters.ppblt}
                                    type='number'
                                    onChange={setPpbLessThan}
                                    step="1"
                                    required />
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col>
                                <Form.Label column="sm" style={{ fontSize: 12 }}>PPB More than:</Form.Label>
                                <FontAwesomeIcon
                                    title="Gold Parts Per Billion parts"
                                    style={{ marginLeft: 5 }}
                                    icon={faQuestionCircle} />
                            </Col>
                            <Col>
                                <Form.Control
                                    size="sm"
                                    defaultValue={assayFilters.ppbmt}
                                    onChange={setPpbMoreThan}
                                    value={assayFilters.ppbmt}
                                    type='number'
                                    step="1"
                                    required />
                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Label column="sm" style={{ fontSize: 12 }} >Sample Type</Form.Label>
                            <Select isMulti='true'
                                defaultValue={assayFilters.type}
                                onChange={setAssayType}
                                options={sampletypedata}
                                styles={SelectCustomStyles}
                                required />
                        </Form.Group>

                        <br />
                        <Row>
                            <Col>
                                <OverlayTrigger
                                    overlay={<Tooltip id="tooltip-top"> Since the Database is incomplete, manual lookup of the Assay report will be required </Tooltip>}
                                    placement="top" // You can choose other placements like "right", "bottom", "left" 
                                >
                                    <Form.Check // prettier-ignore

                                        checked={assayFilters.nullValues}
                                        onChange={() => toggleNullValues()}
                                        name="nullValues"
                                        label="Include Samples With Missing PPB Values"
                                    />
                                </OverlayTrigger>
                            </Col>
                        </Row>
                        {loadDatePeriodFilter()}
                    </Tab>
                    <Tab eventKey="anumberr" title="A Number">

                        <Form onSubmit={(e) => LookupANumber(e)} >


                            <Form.Label style={{ fontSize: 12 }} column="sm" >Display all soil samples within this A Number</Form.Label>
                            <Row>
                                <Col xs='6'>
                                    <InputGroup className="mb-2">
                                        <InputGroup.Text>A</InputGroup.Text>
                                        <Form.Control size="sm" name='anumber' type='number' value={anumber}
                                            onChange={(e) => setAnumber(e.target.valueAsNumber)} 
                                            min="1" required />
                                    </InputGroup>
                                </Col>
                                <Col>
                                    <button className="btn btn-primary btn-sm" style={{ marginRight: 5 }} type="submit">Lookup</button>
                                    <button className="btn btn-danger btn-sm" onClick={() => {
                                        setAnumber(0);
                                        const updatedFilters = { ...assayFilters, anumber: 0 };
                                        setAssayFilters(updatedFilters);
                                        
                                        // Trigger standard query when clearing
                                        if (goldfindermap && goldfindermap.getZoom() > 10.6) {
                                            const bounds = goldfindermap.getBounds();
                                            const wfsbbox = [
                                                bounds.getSouthWest().lng, 
                                                bounds.getSouthWest().lat, 
                                                bounds.getNorthEast().lng, 
                                                bounds.getNorthEast().lat
                                            ].join();
                                            
                                            // Use updated filters for the standard query
                                            debouncedQueryAssayWFS(wfsbbox, setAssayGeoJson, updatedFilters);
                                        } else {
                                            // Clear results if zoomed out too far
                                            setAssayGeoJson({
                                                type: "FeatureCollection",
                                                features: []
                                            });
                                        }
                                    }}>Clear</button>

                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="sampleid" title="Sample ID">

                        <Form onSubmit={(e) => LookupSampleId(e)} >

                            <Form.Label style={{ fontSize: 12 }} column="sm" >Find soil sample by ID or Company Sample ID</Form.Label>
                            <Row>
                                <Col xs='6'>
                                    <InputGroup className="mb-2">
                                        <InputGroup.Text>ID</InputGroup.Text>
                                        <Form.Control size="sm" name='sampleId' type='text' value={sampleId}
                                            onChange={(e) => setSampleId(e.target.value)} 
                                            placeholder="e.g. 12345 or ABC-001"
                                            required />
                                    </InputGroup>
                                </Col>
                                <Col>
                                    <button className="btn btn-primary btn-sm" style={{ marginRight: 5 }} type="submit">Lookup</button>
                                    <button type="button" className="btn btn-danger btn-sm" onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setSampleId('');
                                        
                                        // Trigger standard query when clearing
                                        if (goldfindermap && goldfindermap.getZoom() > 10.6) {
                                            const bounds = goldfindermap.getBounds();
                                            const wfsbbox = [
                                                bounds.getSouthWest().lng, 
                                                bounds.getSouthWest().lat, 
                                                bounds.getNorthEast().lng, 
                                                bounds.getNorthEast().lat
                                            ].join();
                                            
                                            // Use current filters for the standard query
                                            debouncedQueryAssayWFS(wfsbbox, setAssayGeoJson, assayFilters);
                                        } else {
                                            // Clear results if zoomed out too far
                                            setAssayGeoJson({
                                                type: "FeatureCollection",
                                                features: []
                                            });
                                        }
                                    }}>Clear</button>

                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="legend" title="Legend">
                        <Table striped bordered >
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}></th>
                                    <th style={{ width: '20%' }} >Colour</th>
                                    <th>Range</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AssayMarkerColourDisplay(assayMarkerColourSettings)}
                                <tr>
                                    <td></td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input type="color" disabled={true} id="head" name="head" value={"#fff"} />
                                    </td>
                                    <td>
                                        <Row>
                                            <Form.Label column="sm">
                                                Missing Values
                                            </Form.Label>
                                        </Row>
                                    </td>
                                </tr>
                            </tbody>


                            <button style={{ margin: 10 }} onClick={addRangeEntry} className='btn btn-success btn-sm '>
                                <i className='fa fa-solid fa-plus'></i>
                            </button>
                            <button style={{ margin: 10 }} onClick={(e) => { setAssayMarkerColourSettings(defaultAssayMArkerColourSettings) }} className='btn btn-warning btn-sm '>
                                Reset
                            </button>


                        </Table>
                    </Tab>
                </Tabs>
                <br />
                <Row>
                    <Col className='text-center mb-1'  >
                        <button className="btn btn-secondary btn-sm" onClick={markersToKml}>Export results to KML file</button>
                    </Col>
                    {/*
                    
                    <Col className='text-center'  >
                        <button className="btn btn-secondary btn-sm" onClick={markersToGeoJson}>Export to results to GEOJSON file</button>
                    </Col>       
                    */}

                </Row>
                <Row>
                <Col className='text-center mb-3'  >
                        Note: Export is limited to top 500 samples
                    </Col>
                </Row>






            </div>


        </>

    )
}

